import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type {
  BatteryProposalVppProgramsDto,
  UpdateBatteryProposalVppProgramsDto,
} from "../dto/battery-proposal.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

export default function useUpdateBatteryProposalVppPrograms(): UseMutationResult<
  BatteryProposalVppProgramsDto,
  unknown,
  { proposalId: string; body: UpdateBatteryProposalVppProgramsDto }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, body }) =>
      batteryProposalService.updateVppPrograms(proposalId, body),
    onSuccess: (programs, { proposalId }) => {
      // The response is the canonical catalog after saving — adopt it as-is.
      queryClient.setQueryData(
        queryKeys.batteryProposal.vppPrograms(proposalId),
        programs,
      )
      // Saved selections change the VPP block the financial summary serves to
      // the seller view, the public share and the export.
      void queryClient.invalidateQueries({
        queryKey: queryKeys.batteryProposal.financialSummary(proposalId),
      })
    },
  })
}
